<template>
	<form
		action="/login/doLogin"
		method="post"
		class="navbar-form navbar-right pa-0"
		role="form"
	>
		<div class="form-group hidden-md">
			<input
				type="email"
				name="email_address"
				:placeholder="$gettext('Email')"
				class="form-control"
			>
		</div>
		<div class="form-group hidden-md inside-wrapper">
			<input
				:type="showPassword ? 'text' : 'password'"
				name="password"
				:placeholder="$gettext('Password')"
				class="form-control"
			>
			<button
				type="button"
				class="btn hide-password-button form-group hidden-md"
				@click="showPassword = !showPassword"
			>
				<v-icon
					:icon="showPassword? '$eye' : '$eyeOff'"
				/>
			</button>
		</div>
		<button
			type="submit"
			class="btn btn-primary"
		>
			<translate>
				Sign in
			</translate>
		</button>
	</form>
</template>

<script>
export default {
	name: 'LoginForm',
	data () {
		return {
			showPassword: false,
		};
	}
};
</script>

<style scoped lang="less">
.hide-password-button {
	color: #393939 !important;
	background: #ffffff;
	border: 1px solid #cccccc;
	box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
	border-radius: 0 4px 4px 0;

}

.inside-wrapper {
	position: relative;
}

.inside-wrapper input {
	padding-right: 40px;
}

.inside-wrapper button {
	position: absolute;
	top: 0;
	right: 0;
}
</style>
